import { useEffect, useState } from 'react';
import { getSalesComparison, SalesComparison } from './salesComparisonApi';

export type Period = 'week' | 'month';
export type ReceiptMode = 'all' | 'pos';

// Owns the report selection (period / current-or-previous / receipt mode) and (re)fetches the computed
// report whenever it changes.
export function useSalesComparison() {
    const [period, setPeriod] = useState<Period>('week');
    const [current, setCurrent] = useState(true);
    const [receiptMode, setReceiptMode] = useState<ReceiptMode>('all');
    const [data, setData] = useState<SalesComparison | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        getSalesComparison(period, current, receiptMode)
            .then(result => { if (!cancelled) setData(result); })
            .catch(e => { if (!cancelled) setError(String(e)); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [period, current, receiptMode]);

    return { period, current, receiptMode, setPeriod, setCurrent, setReceiptMode, data, loading, error };
}
